import type { StorageFolder, StorageObject } from "../../API";

export type UploadKind = "image" | "publication";

export const UPLOAD_OPTIONS: Array<{
	id: UploadKind;
	title: string;
	description: string;
	helper: string;
}> = [
	{
		id: "image",
		title: "Images",
		description: "PNG, JPG, GIF, WebP, SVG, BMP",
		helper: "Stored under the images root folder."
	},
	{
		id: "publication",
		title: "Publications",
		description: "PDF, DOC(X), PPT(X), TXT, RTF",
		helper: "Stored under the publications root folder."
	}
];

export interface UploadFormState {
	title: string;
	fileName: string;
	folder: string;
	taxonomyIds: string[];
	file: File | null;
}

export type Step = 1 | 2 | 3;
export type ViewMode = "grid" | "list";

export interface BrowseState {
	folder: StorageFolder | null;
	breadcrumbs: StorageFolder[];
	children: StorageFolder[];
	objects: StorageObject[];
	page: number;
	pageSize: number;
	hasMore: boolean;
	totalObjects: number;
}

export type BrowseItem =
	| {
			type: "folder";
			key: string;
			name: string;
			path: string;
			folder: StorageFolder;
	  }
	| {
			type: "file";
			key: string;
			name: string;
			path: string;
			object: StorageObject;
	  };

export const ROOT_PLACEHOLDER = "__root__";
export const DEFAULT_STORAGE_PATH = ROOT_PLACEHOLDER;
export const ROOT_PATHS: Array<{ path: string; label: string; kind: string; icon: "image" | "document" }> = [
	{ path: "images", label: "Images", kind: "image", icon: "image" },
	{ path: "logo", label: "Logo", kind: "image", icon: "image" },
	{ path: "publications", label: "Publications", kind: "publication", icon: "document" }
];
export const BROWSE_PAGE_SIZE = 100;
export const URL_PATH_PARAM = "path";

export const initialFormState: UploadFormState = {
	title: "",
	fileName: "",
	folder: "",
	taxonomyIds: [],
	file: null
};

export const PUBLICATION_ACCEPT = ".pdf,.doc,.docx,.ppt,.pptx,.txt,.rtf";
export const PUBLICATION_EXTENSIONS = new Set(["pdf", "doc", "docx", "ppt", "pptx", "txt", "rtf"]);

export type UploadSectionProps = {
	form: UploadFormState;
	onFileChange: (file: File | null) => void;
	previewUrl: string | null;
	previewType: "image" | "pdf" | "other" | null;
};
